import { render, staticRenderFns } from "./CheckKo.vue?vue&type=template&id=5631546c&"
import script from "./CheckKo.vue?vue&type=script&lang=js&"
export * from "./CheckKo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports